'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Panels = require('../../main/jsx/Panels');

var _Panels2 = _interopRequireDefault(_Panels);

var _simplePanelsAccordion = require('../../simple-panels-accordion');

var _simplePanelsAccordion2 = _interopRequireDefault(_simplePanelsAccordion);

var _noImagePanel = require('../../../../molecules/no-image-panel');

var _noImagePanel2 = _interopRequireDefault(_noImagePanel);

var _clone = require('../../../../../utilities/clone');

var _clone2 = _interopRequireDefault(_clone);

var _moleculesMap = require('./../../utilities/moleculesMap');

var _moleculesMap2 = _interopRequireDefault(_moleculesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultimediaPanelsAccordion = function (_SimplePanelsAccordio) {
  _inherits(MultimediaPanelsAccordion, _SimplePanelsAccordio);

  function MultimediaPanelsAccordion(props) {
    _classCallCheck(this, MultimediaPanelsAccordion);

    var _this = _possibleConstructorReturn(this, (MultimediaPanelsAccordion.__proto__ || Object.getPrototypeOf(MultimediaPanelsAccordion)).call(this, props));

    _this.handleOpenItem = _this.handleOpenItem.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);

    _this.state = {
      isMobile: false
    };

    _this.moleculesMap = _moleculesMap2.default;
    return _this;
  }

  return MultimediaPanelsAccordion;
}(_simplePanelsAccordion2.default);

exports.default = MultimediaPanelsAccordion;


MultimediaPanelsAccordion.propTypes = _Panels2.default.propTypes;

var items = [_noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps];
MultimediaPanelsAccordion.defaultProps = (0, _clone2.default)(_Panels2.default.defaultProps);
MultimediaPanelsAccordion.defaultProps.content.items = items;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/panels/multimedia-panels-accordion/jsx/MultimediaPanelsAccordion.js
// module id = 1125
// module chunks = 4